import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "long-press-event";
import App from "./App";
import "./index.css";
import { initTelemetry } from "./telemetry";
import { initInstrumentation } from "~/hooks/useInstrumentation";
import { ConsentBanner, ConsentProvider } from "./components/consent";

initTelemetry();
initInstrumentation();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ConsentProvider>
        <App />
        <ConsentBanner />
      </ConsentProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
